import { DOMAIN_TYPES } from "./domainTypes";

const defaultColors = {
  primary: "#3b82f6",
  secondary: "#8b5cf6",
  accent: "#f59e0b",
  background: "#f8fafc",
  paper: "#ffffff",
  textDark: "#1e293b",
  textLight: "#64748b",
  border: "#e2e8f0",
  success: "#10b981",
  warning: "#f59e0b",
  error: "#ef4444",
  info: "#3b82f6"
};

export const domainColorMap = {
  [DOMAIN_TYPES.EDUCATION]: {
    primary: "var(--education-primary, #746EAC)",
    secondary: "var(--education-secondary, #3B9394)",
    accent: "#B5A262",
    background: "#f8f9fa",
    paper: "#ffffff",
    textDark: "#2d3436",
    textLight: "#636e72",
    border: "#e0e0e0",
    success: "#00b894",
    warning: "#fdcb6e",
    error: "#d63031",
    info: "var(--education-secondary, #3B9394)"
  },
  [DOMAIN_TYPES.FLEX_OFFICE]: {
    primary: "var(--flex-primary, #2563EB)",
    secondary: "var(--flex-secondary, #0f172a)",
    accent: "var(--flex-accent, #1d4ed8)",
    background: "var(--flex-bg, #f8f9fa)",
    paper: "var(--flex-surface, #ffffff)",
    textDark: "var(--flex-text, #2d3436)",
    textLight: "var(--flex-text-muted, #636e72)",
    border: "var(--flex-border, #e0e0e0)",
    success: "#00b894",
    warning: "#fdcb6e",
    error: "#d63031",
    info: "var(--flex-primary, #2563EB)"
  },
  [DOMAIN_TYPES.RETAIL]: {
    primary: "#F97316",
    secondary: "#EA580C",
    accent: "#FB923C",
    background: "#f8fafc",
    paper: "#ffffff",
    textDark: "#1e293b",
    textLight: "#64748b",
    border: "#e2e8f0",
    success: "#10b981",
    warning: "#f59e0b",
    error: "#ef4444",
    info: "#F97316"
  },
  [DOMAIN_TYPES.INSTITUTION]: {
    primary: "#1e40af",
    secondary: "#1e3a8a",
    accent: "#c026d3",
    background: "#f0f9ff",
    paper: "#ffffff",
    textDark: "#1e3a8a",
    textLight: "#475569",
    border: "#cbd5e1",
    success: "#059669",
    warning: "#d97706",
    error: "#dc2626",
    info: "#0284c7"
  },
  [DOMAIN_TYPES.ASSESSMENT]: {
    primary: "#7C3AED",
    secondary: "#6D28D9",
    accent: "#A78BFA",
    background: "#f8fafc",
    paper: "#ffffff",
    textDark: "#1e293b",
    textLight: "#64748b",
    border: "#e2e8f0",
    success: "#10b981",
    warning: "#f59e0b",
    error: "#ef4444",
    info: "#7C3AED"
  },
  [DOMAIN_TYPES.SERVICES]: {
    primary: "#059669",
    secondary: "#047857",
    accent: "#34D399",
    background: "#f0fdf4",
    paper: "#ffffff",
    textDark: "#064e3b",
    textLight: "#047857",
    border: "#a7f3d0",
    success: "#059669",
    warning: "#f59e0b",
    error: "#dc2626",
    info: "#059669"
  },
  [DOMAIN_TYPES.WAAS]: {
    primary: "#1f6feb",
    secondary: "#154ea6",
    accent: "#10233f",
    background: "#f8fafc",
    paper: "#ffffff",
    textDark: "#1e293b",
    textLight: "#64748b",
    border: "#dbe4ef",
    success: "#168a5f",
    warning: "#f59e0b",
    error: "#b42318",
    info: "#1f6feb"
  },
  [DOMAIN_TYPES.KRUMAGO]: {
    primary: "#4F46E5",
    secondary: "#4338CA",
    accent: "#818CF8",
    background: "#f8fafc",
    paper: "#ffffff",
    textDark: "#1e293b",
    textLight: "#64748b",
    border: "#e2e8f0",
    success: "#10b981",
    warning: "#f59e0b",
    error: "#ef4444",
    info: "#4F46E5"
  },
  [DOMAIN_TYPES.DEFAULT]: defaultColors
};

const defaultLabels = {
  booking: "Order",
  receipt: "Invoice",
  space: "Item",
  service: "Service",
  invoice: "Invoice"
};

export const domainLabelMap = {
  [DOMAIN_TYPES.FLEX_OFFICE]: {
    booking: "Receipt",
    receipt: "Receipt",
    space: "Space",
    service: "Service",
    invoice: "Invoice"
  },
  [DOMAIN_TYPES.EDUCATION]: {
    booking: "Enrollment",
    receipt: "Receipt",
    space: "Course",
    service: "Class",
    invoice: "Invoice"
  },
  [DOMAIN_TYPES.RETAIL]: {
    booking: "Order",
    receipt: "Invoice",
    space: "Product",
    service: "Service",
    invoice: "Invoice"
  },
  [DOMAIN_TYPES.INSTITUTION]: {
    booking: "Application",
    receipt: "Invoice",
    space: "Program",
    service: "Service",
    invoice: "Invoice"
  },
  [DOMAIN_TYPES.ASSESSMENT]: {
    booking: "Assessment",
    receipt: "Invoice",
    space: "Test",
    service: "Service",
    invoice: "Invoice"
  },
  [DOMAIN_TYPES.SERVICES]: {
    booking: "Booking",
    receipt: "Invoice",
    space: "Service",
    service: "Service",
    invoice: "Invoice"
  },
  [DOMAIN_TYPES.WAAS]: {
    booking: "Inquiry",
    receipt: "Receipt",
    space: "Program",
    service: "Service",
    invoice: "Invoice"
  },
  [DOMAIN_TYPES.DEFAULT]: defaultLabels
};

export const getDomainColors = (domainType) => (
  domainColorMap[domainType] || domainColorMap[DOMAIN_TYPES.DEFAULT]
);

export const getDomainLabels = (domainType) => (
  domainLabelMap[domainType] || domainLabelMap[DOMAIN_TYPES.DEFAULT]
);
